import { useEffect, useRef, useState } from "react";
import {
  Group,
  Text,
  UnstyledButton,
  TextInput,
  Box,
  ActionIcon,
  ThemeIcon,
  useMantineTheme,
  Code,
  Indicator,
  Skeleton,
  Loader,
  CloseButton,
  Tooltip,
  Stack,
  createStyles,
} from "@mantine/core";
import {
  IconArrowUpRight,
  IconLayoutSidebarRightCollapse,
  IconLayoutSidebarRightExpand,
  IconSearch,
  IconX,
} from "@tabler/icons-react";
import { closeAllModals } from "@mantine/modals";
import { useForm } from "@mantine/form";
import { logger } from "utils/logger";
import { useNavigate } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import {
  fetchGlobalSearch,
  getStyleSuccess,
  setFilter,
  setPreviousRoute,
  getGlobalSearchSuccess,
  setGlobalSearch,
} from "app/appSlice";
import ResolverImage from "../resolverImage/ResolverImage";
import { EmptyState } from "../emptyState/EmptyState";
import StylePopover from "../popovers/StylePopover";
import Moment from "react-moment";
// import { createStyles } from "@mantine/emotion";
import MastersList from "./MastersList";

import MasterDrawer from "./MasterDrawer";
import { CompanyTableColumns } from "utils/constants";
import { getCompany } from "utils/helper";
// import type { SpotlightAction } from '@mantine/spotlight';

const useStyles = createStyles((theme, _) => ({
  spotlightItem: {
    width: "100%",
    "&:hover": {
      background: theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[1],
    },
    borderRadius: theme.radius.sm,
  },
  inputWrapper: {
    width: "100%",
    // height: '34px',
    // borderRadiusTop: `${theme.radius.md}px`,
    color: theme.colorScheme === 'dark' ? theme.colors.dark[1] : theme.colors.gray[6],
    backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.white,
    // borderBottom: `1px solid ${theme.colors.dark[6]}`,
    // borderColor: theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.colors.gray[4],
    padding: `0px ${theme.spacing.sm / 2}px`,
    paddingLeft: theme.spacing.md,
   
  },
  input: {
    input: {
      border: 0,
      background: "transparent",
      width: "100%",
      border: 0,
    },
    background: "transparent",
    flex: 1,
    flexGrow: `1 !important`,
  },
  container: {
    background: theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.white,
    overflow: "hidden",
    height: "100vh",
  },
  code: {
    // subscribe to color scheme changes
    border: theme.colorScheme === 'dark' ? `1px solid ${theme.colors.dark[3]}` : `1px solid ${theme.colors.gray[2]}`,
    marginRight: theme.spacing.sm,
   
  },

  resultHolder: {
    transition: "all .2s ease-in-out",
    maxHeight: 50,
    overflow: "hidden",
    "&.open": {
      maxHeight: "90vh",
    },
    // borderBottom: `1px solid ${theme.colors.dark[3]}`,
    // [u.light]: {
    //   borderBottom: `1px solid ${theme.colors.gray[2]}`,
    // },
  },
  drawer: {
    maxWidth: 0,
    transition: "all .2s ease-in-out",
    overflow: "hidden",
    // maxHeight: 0,
    opacity: 0,
    // borderLeft: `1px solid ${theme.colors.dark[6]}`,

    
    "&.open": {
      minWidth: 400,
      maxWidth: 400,
      maxHeight: "100%",
      opacity: 1,
    },
  },
}));

const SpotlightForm = ({
  style,
  filter,
  success,
  error,
  user,
  aggData,
  globalSearch,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  // const [data, setData] = useState();
  const theme = useMantineTheme();
  const { classes } = useStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const keywordRef = useRef();

  useEffect(() => {
    if (success && success.type === getStyleSuccess.toString()) {
      setIsLoading(false);
    }

    if (success && success.type === getGlobalSearchSuccess.toString()) {
      setIsLoading(false);
    }

    if (error) {
      setIsLoading(false);
    }
    // setIsLoading(true);
  }, [success, error]);

  useEffect(() => {
    setTimeout(() => {
      keywordRef.current?.select();
    }, 200);
  }, []);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        // If asset viewer is open, close it first
        if (globalSearch?.imageModalOpen) {
          dispatch(setGlobalSearch({ ...globalSearch, imageModalOpen: false }));
        } else {
          // Otherwise, close the main modal
          closeAllModals();
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [globalSearch, dispatch]);

  const form = useForm({
    initialValues: {
      keyword: filter.keyword,
    },

    validate: {
      keyword: (value) => (value.length ? null : "Enter style"),
    },
  });

  const onFormSubmit = async (values) => {
    // fetch the timeline.
    logger.log(values);

    setIsLoading(true);

    dispatch(
      setFilter({ keyword: values.keyword, pageIndex: 0, pageSize: 50 })
    );

    // const timeline = await getStyleTimeline({ id: values.keyword });
    // dispatch(fetchStyleTimeline({ keyword: values.keyword }));
    const company = getCompany(aggData);
    dispatch(fetchGlobalSearch({ keyword: values.keyword }, company?.code));
    // setData(timeline.Timeline);
  };

  const [selectedItem, setSelectedItem] = useState(null);
  const drawerOpen = globalSearch?.drawerOpen ?? false;

  useEffect(() => {
    if (globalSearch?.results && globalSearch.results.length === 0) {
      setSelectedItem(null);
      if (drawerOpen) {
        dispatch(setGlobalSearch({ ...globalSearch, drawerOpen: false }));
      }
    }
  }, [globalSearch?.results, drawerOpen, dispatch, globalSearch]);

  const onItemClick = (route) => {
    // navigate(route);
    // closeAllModals();
    logger.log(route.original, filter);

    setSelectedItem({ ...route.original });
    const {styleNumber, ...rest} = route.original;
    const tmpGlobalSearch = { ...globalSearch, drawerOpen: true };
    dispatch(setGlobalSearch(tmpGlobalSearch  ));
  };

  // const styleItem = style && style.styles && style.styles.length ? [style.styles[0]] : null;
  // const styleItem =
  //   style && style.baseStyle && style.baseStyle.length
  //     ? [style.baseStyle[0]]
  //     : null;

  const styleItem =
    style && style.masters && style.masters.length ? [style.masters[0]] : null;

  const loaderRows = [1, 2].map((val, key) => (
    <Box key={key} className="" pt={"md"}>
      <ItemRenderer />
    </Box>
  ));

  logger.log(style, globalSearch);
  const columns = CompanyTableColumns[getCompany(aggData)?.code]?.seasonMasters || [];
  

  const [panelHeight, setPanelHeight] = useState("100%");
  const modalContentRef = useRef(null);
  const containerRef = useRef(null);

  // Calculate panel height using ResizeObserver for efficiency
  useEffect(() => {
    let cleanup = null;
    let timeoutId = null;

    const updateHeight = (height) => {
      const newHeight = height - 50;
      if (newHeight > 0) {
        setPanelHeight(newHeight);
      } else {
        // Fallback when modal is small: use viewport height
        setPanelHeight(Math.max(200, window.innerHeight - 100));
      }
    };

    // Find modal element: try selector first, then walk up from our container
    const findModalElement = () => {
      return (
        document.querySelector(".spotlightModal") ||
        document.querySelector("[class*='Modal-inner']") ||
        document.querySelector("[class*='Modal-content']") ||
        document.querySelector("[class*='Modal-modal']") ||
        containerRef.current?.closest("[class*='Modal']")
      );
    };

    const findAndObserve = () => {
      const modalContent = findModalElement();
      if (!modalContent) return;

      modalContentRef.current = modalContent;
      const height = modalContent.clientHeight || modalContent.getBoundingClientRect().height;
      updateHeight(height);

      const resizeObserver = new ResizeObserver((entries) => {
        const entry = entries[0];
        if (entry) {
          const h = entry.contentRect.height || entry.target.clientHeight;
          updateHeight(h);
        }
      });

      resizeObserver.observe(modalContent);

      return () => {
        resizeObserver.disconnect();
        modalContentRef.current = null;
      };
    };

    const tryObserve = (retries = 0) => {
      const maxRetries = 20;
      cleanup = findAndObserve();
      if (!cleanup && retries < maxRetries) {
        timeoutId = setTimeout(() => tryObserve(retries + 1), 100);
      } else if (!cleanup) {
        // Fallback: use viewport height when modal element not found
        updateHeight(window.innerHeight);
      }
    };

    // Use double RAF to ensure modal has fully rendered (Mantine may animate in)
    const rafId = requestAnimationFrame(() => {
      requestAnimationFrame(tryObserve);
    });

    return () => {
      cancelAnimationFrame(rafId);
      if (timeoutId) clearTimeout(timeoutId);
      cleanup?.();
    };
  }, [globalSearch?.results, drawerOpen]);

  return (
    <div ref={containerRef} className={classes.container}>
      <Group
        className={
          // style ? [classes.resultHolder, "open"] : [classes.resultHolder]
          globalSearch?.results && globalSearch?.results.length
            ? [classes.resultHolder, "open"]
            : [classes.resultHolder]
        }
        style={{ height: "100%", width: "100%" }}
        wrap="nowrap"
        align="flex-start"
        justify="flex-start"
        gap="xs"
      >
        <div
          style={{
            height: "100%",
            width: "100%",
            paddingBottom: 50,
            maxWidth: drawerOpen ? `calc(100% - 420px)` : `100%`,
            transition: "all .2s ease-in-out",
          }}
        >
          <form onSubmit={form.onSubmit((values) => onFormSubmit(values))}>
            <Group
              wrap="nowrap"
              className={classes.inputWrapper}
              gap={0}
              pl={0}
              // pr={"md"}
            >
              {/* <IconSearch size={20} c="grey" /> */}
              <TextInput
                icon={<IconSearch size={20} c="grey" />}
                p={0}
                className={classes.input}
                size="lg"
                placeholder="Enter Keyword or Style Number"
                data-autofocus
                ref={keywordRef}
                {...form.getInputProps("keyword")}
              />
              {form.isValid() ? (
                <ActionIcon
                  variant="transparent"
                  mr={"xs"}
                  onClick={(e) => {
                    form.setFieldValue("keyword", "");
                    keywordRef.current?.focus();
                    dispatch(
                      setFilter({ keyword: "", pageIndex: 0, pageSize: 50 })
                    );
                  }}
                >
                  <IconX color="white" stroke={1} />
                </ActionIcon>
              ) : null}
              {isLoading ? (
                <Loader size={"sm"} type="dots" mr={"lg"} />
              ) : (
                <Code className={classes.code}>↵ Enter</Code>
              )}

              {/* <CloseButton onClick={() => closeAllModals()} /> */}
              {globalSearch?.results && globalSearch?.results.length ? (
                <Tooltip
                  position="bottom"
                  label={drawerOpen ? "Hide Info Panel" : "Show Info Panel"}
                >
                  <ActionIcon
                    mr={"sm"}
                    variant="default"
                    onClick={() =>
                      dispatch(
                        setGlobalSearch({
                          ...globalSearch,
                          drawerOpen: !drawerOpen,
                        })
                      )
                    }
                    size={"lg"}
                  >
                    {drawerOpen ? (
                      <IconLayoutSidebarRightCollapse size={18} />
                    ) : (
                      <IconLayoutSidebarRightExpand size={18} />
                    )}
                  </ActionIcon>
                </Tooltip>
              ) : null}
            </Group>
          </form>
          <Box>
            <Box p={0} pt={0}>
              {/* <Table highlightOnHover> */}
              <Box px={"sm"} pb={0}>
                {isLoading ? <ItemRenderer /> : null}

                {!isLoading &&
                globalSearch?.results &&
                globalSearch?.results.length ? (
                  <Group wrap="nowrap" justify="flex-start" align="flex-start">
                    <div
                      style={{
                        height: "100%",
                        // paddingBottom: 33,
                        maxWidth: `calc(100% - 0px)`,
                      }}
                    >
                      <div
                        className="main-container-content "
                        style={{
                          position: "relative",
                          height: panelHeight,
                          // height:400
                        }}
                      >
                        <MastersList
                          columns={columns ?? []}
                          originalData={globalSearch?.results || []}
                          loading={isLoading}
                          data={globalSearch?.results || []}
                          onItemClick={(item) => onItemClick(item)}
                          selectedItems={
                            // globalSearch?.style ? [globalSearch?.style] : []
                            // we need to use the selected item if it is available otherwise use the global search style
                            selectedItem ? [selectedItem] : []
                          }
                          leftColumnPinning={["TARGET KEYCODE"]}
                          filter={filter}
                          setFilter={(filter) => {
                            dispatch(setFilter(filter));
                          }}
                          // onMenuItemClick={onMenuItemClick}
                          // onItemSelected={onItemSelected}
                          // selectedItems={selectedStyles}
                          // filter={wipFilter}
                          // actionMenu={rowMenuItems}
                          // columns={columns}
                          // setFilter={setWipFilter}
                        />
                      </div>
                    </div>
                  </Group>
                ) : null}

                {!isLoading && style && style.styles && style.styles.length ? (
                  <div>
                    {" "}
                    {styleItem.map((val, idx) => {
                      return (
                        <StylePopover
                          key={idx}
                          data={{
                            ...val,
                            preview:
                              style.styles && style.styles.length
                                ? style.styles[0].preview
                                : "",
                            stylePart: val.styleNumber,
                            styleSort: val.styleNumber,
                            assets: style.styles.map((val) => ({ ...val })),
                          }}
                          onShowDetails={closeAllModals}
                        >
                          <UnstyledButton
                            onClick={() =>
                              onItemClick(`/distributions/${val.styleNumber}`)
                            }
                            className={classes.spotlightItem}
                            px={"sm"}
                            py={"md"}
                            key={idx}
                          >
                            <Group justify="space-between" wrap="nowrap">
                              <Group spacing="sm" align="start" wrap="nowrap">
                                <div style={{ position: "relative" }}>
                                  <Indicator
                                    inline
                                    label={style.styles.length}
                                    style={{
                                      ".mantine-MachineNumber-currentNumber": {
                                        lineHeight: `16px !important`,
                                      },
                                    }}
                                    size={16}
                                  >
                                    <div style={{ position: "relative" }}>
                                      <ResolverImage
                                        width={30}
                                        height={30}
                                        src={
                                          style.styles && style.styles.length
                                            ? style.styles[0].thumb
                                            : ""
                                        }
                                      />
                                    </div>
                                  </Indicator>
                                </div>

                                <div>
                                  <Text size="sm" weight={500}>
                                    {val.styleNumber}
                                  </Text>
                                  <Group>
                                    <Text
                                      size="xs"
                                      c="dimmed"
                                      truncate
                                      style={{ maxWidth: 300 }}
                                    >
                                      {val.name}
                                    </Text>
                                  </Group>
                                  {val.distributionDate &&
                                  val.distributionDate.length ? (
                                    <Group>
                                      <Text size="xs" c="dimmed">
                                        Distributed →{" "}
                                        <Moment
                                          date={val.distributionDate}
                                          parse="YYYY-MM-DD-hh-mm-ss"
                                          format="DD/MM/YYYY"
                                          trim
                                        />{" "}
                                      </Text>
                                    </Group>
                                  ) : null}

                                  {/* <Group>
                                                            <Badge c={getStyleStatusColor(val.status)}>{val.status}</Badge>
                                                                <Text size='sm'>
                                                                    <Moment date={val.distributionDate} parse='YYYY-MM-DD-hh-mm-ss' format='DD/MM/YYYY' trim />
                                                                </Text>
                                                            </Group> */}
                                </div>
                              </Group>
                              <Group wrap="nowrap">
                                {/* <Badge c={getStyleStatusColor(val.status)}>
                              {val.status}
                            </Badge> */}
                                <ThemeIcon variant="light">
                                  <IconArrowUpRight size={18} />
                                </ThemeIcon>
                              </Group>
                            </Group>
                          </UnstyledButton>
                        </StylePopover>
                      );
                    })}{" "}
                  </div>
                ) : null}
                {/* </Table> */}
                {!isLoading &&
                style &&
                style.styles &&
                style.styles.length === 0 ? (
                  <EmptyState
                    style={{ paddingTop: 10, paddingBottom: 10 }}
                    showImage={false}
                    caption="No style found"
                  />
                ) : null}
              </Box>
            </Box>
          </Box>
        </div>
        <div
          className={[classes.drawer, drawerOpen && "open"]
            .filter(Boolean)
            .join(" ")}
          style={{ minHeight: "100%", height: panelHeight }}
        >
          <Group px={0} py="sm" pb="sm" align="center" position="apart">
            <Text size="md">Style Details</Text>
            <CloseButton
              title="Close Info Panel"
              onClick={() =>
                dispatch(
                  setGlobalSearch({ ...globalSearch, drawerOpen: false })
                )
              }
            />
          </Group>

          <MasterDrawer
            open={drawerOpen}
            onClose={() =>
              dispatch(setGlobalSearch({ ...globalSearch, drawerOpen: false }))
            }
            item={selectedItem}
            globalSearch={globalSearch}
            user={user}
            aggData={aggData}
          />
        </div>
      </Group>

      {globalSearch?.results && globalSearch?.results.length === 0 ? (
        <Box
          className="empty-state-container"
          style={{ borderTop: `1px solid ${theme.colors.dark[8]}` }}
        >
          <EmptyState
            style={{ paddingTop: 10, paddingBottom: 10 }}
            showImage={false}
            caption="No results found"
          />
        </Box>
      ) : null}
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.auth.user,
  aggData: state.appReducer.aggData,
  isLoading: state.appReducer.loading,
  globalSearch: state.appReducer.globalSearch,
  style: state.appReducer.style,
  filter: state.appReducer.filter,
  success: state.appReducer.success,
  error: state.appReducer.error,
});

const mapDispatchToProps = { setPreviousRoute };

export default connect(mapStateToProps, mapDispatchToProps)(SpotlightForm);

const ItemRenderer = () => {
  return (
    <Stack py={3} px={"sm"}>
      <Group position="apart">
        <Group style={{ width: "100%" }} gap={"xs"}>
          <Skeleton height={16} radius="sm" width={"10%"} pr={"sm"} />
          <Skeleton height={16} radius="xl" width={"10%"} />
          <Skeleton height={16} radius="sm" width={"72%"} />
          {/* <Skeleton height={10} radius="xl" width={100} /> */}
        </Group>
      </Group>

      <Group position="apart">
        <Group style={{ width: "100%" }} gap={"xs"}>
          <Skeleton height={16} radius="sm" width={"10%"} pr={"sm"} />
          <Skeleton height={16} radius="xl" width={"10%"} />
          <Skeleton height={16} radius="sm" width={"72%"} />
          {/* <Skeleton height={10} radius="xl" width={100} /> */}
        </Group>
      </Group>
    </Stack>
  );
};
